import { ErrorObject } from 'ajv'

export const getErrorMessage = (errors: ErrorObject[] | null, path: string, field?: string) => {
  if (!errors || errors.length === 0) return ''

  const error = errors.find(
    (error) => error.instancePath === path || (path.indexOf(error?.params?.errors[0]?.params?.missingProperty) >= 0 && path.length == error?.params?.errors[0]?.params?.missingProperty.length + 1)
  )

  return error?.message ? `${field ? `${field} ` : ''}${error.message}` : ''
}

export interface Errors {
  [key: string]: string
}
